import { createSlice } from '@reduxjs/toolkit';
import { getCaseStates, getCaseStatesPag, getCaseSubStatesPag, getSubStates } from './thunks';
import { logOut } from '../authentication/authenticationSlice';

const initialState = {
  caseStates: [],
  caseSubStates: [],
  caseStatesAdmin: {
    pageIndex: 0,
    totalRecords: 10,
    totalPages: 1,
    pageSize: 10,
    hasPreviousPage: false,
    hasNextPage: false,
    elements: [],
  },
  caseSubStatesAdmin: {
    pageIndex: 0,
    totalRecords: 10,
    totalPages: 1,
    pageSize: 10,
    hasPreviousPage: false,
    hasNextPage: false,
    elements: [],
  },
  loading: 'idle',
  loadingPag: 'idle',
  subStateLoading: 'idle',
  error: null,
};

const caseStateSlice = createSlice({
  name: 'caseStates',
  initialState,
  reducers: {
    clearCaseStateError: (state) => {
      state.error = null;
      state.loading = 'idle';
    },
  },
  extraReducers: {
    [getCaseStates.pending]: (state) => {
      state.loading = 'loading';
      state.error = null;
    },
    [getCaseStates.fulfilled]: (state, action) => {
      state.loading = 'succeeded';
      state.caseStates = action.payload;
    },
    [getCaseStates.rejected]: (state, action) => {
      state.loading = 'failed';
      state.error = action.error.message;
    },
    [getCaseStatesPag.pending]: (state) => {
      state.loadingPag = 'loading';
      state.error = null;
    },
    [getCaseStatesPag.fulfilled]: (state, action) => {
      state.loadingPag = 'succeeded';
      state.caseStatesAdmin.elements = action.payload.elements;
      state.caseStatesAdmin.pageIndex = action.payload.pageIndex;
      state.caseStatesAdmin.totalRecords = action.payload.totalRecords;
      state.caseStatesAdmin.totalPages = action.payload.totalPages;
      state.caseStatesAdmin.pageSize = action.payload.pageSize;
      state.caseStatesAdmin.hasPreviousPage = action.payload.hasPreviousPage;
      state.caseStatesAdmin.hasNextPage = action.payload.hasNextPage;
    },
    [getCaseStatesPag.rejected]: (state, action) => {
      state.loadingPag = 'failed';
      state.error = action.error.message;
    },
    [getSubStates.pending]: (state) => {
      state.subStateLoading = 'loading';
      state.error = null;
    },
    [getSubStates.fulfilled]: (state, action) => {
      state.subStateLoading = 'succeeded';
      state.caseSubStates = action.payload;
    },
    [getSubStates.rejected]: (state, action) => {
      state.subStateLoading = 'failed';
      state.error = action.error.message;
    },
    [getCaseSubStatesPag.pending]: (state) => {
      state.subStateLoading = 'loading';
      state.error = null;
    },
    [getCaseSubStatesPag.fulfilled]: (state, action) => {
      state.subStateLoading = 'succeeded';
      state.caseSubStatesAdmin.elements = action.payload.elements;
      state.caseSubStatesAdmin.pageIndex = action.payload.pageIndex;
      state.caseSubStatesAdmin.totalRecords = action.payload.totalRecords;
      state.caseSubStatesAdmin.totalPages = action.payload.totalPages;
      state.caseSubStatesAdmin.pageSize = action.payload.pageSize;
      state.caseSubStatesAdmin.hasPreviousPage = action.payload.hasPreviousPage;
      state.caseSubStatesAdmin.hasNextPage = action.payload.hasNextPage;
    },
    [getCaseSubStatesPag.rejected]: (state, action) => {
      state.subStateLoading = 'failed';
      state.error = action.error.message;
    },
    [logOut]: (state) => initialState,
  },
});

export const { clearCaseStateError } = caseStateSlice.actions;
export default caseStateSlice.reducer;
